import { makeAutoObservable, toJS } from "mobx";
import clipIdStore from "@/stores/previewStore/clipId";
import { Message } from '@arco-design/web-react'
type TimelineData = {
  timeline: {
    VideoTracks: any[],
  }
}
export const aspectObj = {
  '9:16': {
    width: '360',
    height: '640'
  },
  '16:9': {
    width: '640',
    height: '360'
  },
  '3:4': {
    width: '360',
    height: '480'
  },
  '4:3': {
    width: '480',
    height: '360'
  },
  '1:1': {
    width: '360',
    height: '360'
  }
}
export const getScale = (width, height, aspect) => {
  const scale = width / height
  let radio = null
  if (aspect === '9:16') {
    radio = 9/16
  } else if (aspect === '16:9') {
    radio = 16/9
  } else if (aspect === '1:1') {
    radio = 1
  } else if (aspect === '4:3') {
    radio = 4/3
  } else if (aspect === '3:4') {
    radio = 3/4
  }
  const sh = radio / scale  * 0.5
  return sh
}


class YsVideoStore {
  shape = "horizontal"
  id = null
  name = "" // 模板名称
  folder_id = null // 文件夹id
  sort= "custom"
  width = "1080" // 视频宽
  height = "1920" // 视频高
  source_file_id = null
  image_name = ""
  url = ""
  AspectRatio = "9:16"
  timeline: TimelineData = {
    timeline: {
      VideoTracks: [],
    }
  }
  previewData: unknown[] = []
  ratio = "9:16"
  stepIndex = 0
  slectType = 'Text'
  stepList: TimelineData[] = []
  lockList: {id: number, lock: boolean}[] = []
  customList: { id: number; coverType: number; customList?: any[] }[] = [];
  captions= []
  captionId = null // 字幕
  fontList = []
  constructor() {
    makeAutoObservable(this);
  }

  // 切换锁定状态
  toggleClipLock(clipId: number) {
    const item = this.lockList.find(item => item.id === clipId);
    if (item) {
      item.lock = !item.lock;
    } else {
      this.lockList.push({ id: clipId, lock: true });
    }
  }

  // 查询锁定状态
  isClipLocked(clipId: number): boolean {
    const item = this.lockList.find(item => item.id === clipId);
    return item ? item.lock : false;
  }

  // 记录当前 timeline 快照
  recordStep() {
    this.stepList.push(toJS(this.timeline));
    this.stepIndex = this.stepList.length - 1;
    console.log(JSON.stringify(this.stepList), 'stepList')
  }

  // 上一步
  prevStep() {
    if (this.stepIndex > 0) {
      this.stepIndex--;
      this.timeline = toJS(this.stepList[this.stepIndex]);
    }
  }

  // 下一步
  nextStep() {
    if (this.stepIndex < this.stepList.length - 1) {
      this.stepIndex++;
      this.timeline = toJS(this.stepList[this.stepIndex]);
    }
  }

  initTimeline() {
    this.timeline.timeline.VideoTracks = [
      {
        "Id": Date.now() + parseInt(String(Math.random() * 10000)),
        "Type": "Video",
        "VideoTrackClips": []
      },
      {
        "Id": Date.now() + parseInt(String(Math.random() * 10000)),
        "Type": "Image",
        "VideoTrackClips": []
      },
      {
        "Id": Date.now() + parseInt(String(Math.random() * 10000)),
        "Type": "SubTitle",
        "VideoTrackClips": []
      }
    ]
  }

  // 批量初始化图片
  public initImage(params: any[]) {
    this.timeline.timeline.VideoTracks.forEach((item) => {
      if (item.Type === "Image") {
        params.forEach((img: any, idx) => {
          console.log(img, 'img')
          const sh = getScale(img.width, img.height, '9:16')
          const id = Date.now() + parseInt(String(Math.random() * 10000));
          item.VideoTrackClips.push({
            "Id": id,
            "Type": "Image",
            ...(img?.MediaId && !img?.MediaURL
              ? { MediaId: img?.MediaId }
              : {}),
            ...(img?.MediaURL ? { MediaURL: img?.MediaURL } : {}),
            "X": Number(0.1 * (idx)),
            "Y": Number(0.1 * (idx)),
            "AdaptMode": "Fill",
            "Width": 0.5,
            "Height": sh,
            "Duration": 20,
            "Speed": 1,
            "W": img.width,
            "H": img.height,
            "TrackId": id,
            "Name": img.Name
          });
          this.slectType = 'Image'
          this.recordStep();
          setTimeout(() => {
            clipIdStore.setClipId(id)
          }, 1000)
        })
      }
    })
  }

  public initVideo(params: any) {
    this.timeline.timeline.VideoTracks.forEach((item) => {
      if (item.Type === "Video") {
        const id = Date.now() + parseInt(String(Math.random() * 10000));
        if (item.VideoTrackClips?.length > 0 && params.Y === 0) {
          Message.warning('竖屏组件只能添加一个！')
          return
        }
        if (item.VideoTrackClips?.length > 0 && params.Y === 0.5) {
          Message.warning('横屏组件只能添加一个！')
          return
        }
        item.VideoTrackClips.push({
          "Id": id,
          "Type": "Video",
          "MediaId": params?.MediaId,
          "MediaURL": params?.MediaURL,
          "X": params.X,
          "Y": params.Y,
          "AdaptMode": "Contain",
          "Width": params.Width,
          "Height": params.Height,
          "In": 1,
          "Out": 1,
          "TimelineIn": undefined,
          "TimelineOut": undefined,
          "Duration": 20,
          "Speed": 1,
          "W": params.width,
          "H": params.height,
          "TrackId": id,
          "Name": params.Name
        })
        this.slectType = 'Video'
        this.recordStep();
        setTimeout(() => {
          if (params.Id) {
            clipIdStore.setClipId(params.Id)
          } else {
            clipIdStore.setClipId(id)
          }
        }, 1000)
      }
    })
  }
  // 初始化文字
  public initText (params: any, type = 0) {
    this.timeline.timeline.VideoTracks.forEach((item) => {
      if (item.Type === "SubTitle") {
        const id = Date.now() + parseInt(String(Math.random() * 10000));
        item.VideoTrackClips.push({
          "Id": id,
          "Type": "Text",
          "X": 0.5,
          "Y": 0.5,
          "Content": "占位文本",
          "Alignment": "Center",
          "FontSize": 40,
          "FontColor": "#ffffff",
          "FontColorOpacity": 1,
          "EffectColorStyle": "",
          "Outline": 2,
          "OutlineColour": "#000000",
          "Shadow": 0,
          "BackColour": "",
          "Font": "douyinmeihaotiBold",
          "FontUrl": "",
          "FontFace": {
            "Bold": false,
            "Italic": false,
            "Underline": false
          },
          "TimelineIn": undefined,
          "TimelineOut": undefined,
          "Spacing": 0,
          "LineSpacing": 0,
          "Angle": 0,
          "SubtitleEffects": [],
          "AdaptMode": "AutoWrap",
          "Duration": 0,
          "SizeRequestType": "RealDim",
          "BorderStyle": 1,
          "TrackId": id,
          "TextWidth": 0.8,
          ...params
        })
        this.slectType = 'Text'
        this.recordStep();
        setTimeout(() => {
          if (params.Id) {
            clipIdStore.setClipId(params.Id)
          } else {
            clipIdStore.setClipId(id)
          }
        }, 1000)
        if (params.Id) {
          this.customList.push({
            id: params.Id,
            coverType: type
          })
        } else {
          this.customList.push({
            id: id,
            coverType: type
          })
        }
      }
    })
  }
  public getLayers() {
    // 先合并所有 VideoTrackClips
    let allClips: any[] = [];
    if (this.timeline.timeline.VideoTracks?.length > 0) {
      this.timeline.timeline.VideoTracks.forEach((item) => {
        if (Array.isArray(item.VideoTrackClips)) {
          allClips = allClips.concat(item.VideoTrackClips);
        }
      });
    }
    // 再统一按 TrackId 从小到大排序
    // allClips.sort((a, b) => a.TrackId - b.TrackId);
    return allClips
  }
  public getTexts() {
    // 先合并所有 VideoTrackClips
    let allClips: any[] = [];
    if (this.timeline.timeline.VideoTracks?.length > 0) {
      this.timeline.timeline.VideoTracks.forEach((item) => {
        if (Array.isArray(item.VideoTrackClips) && item.Type === 'SubTitle') {
          allClips = allClips.concat(item.VideoTrackClips);
        }
      });
    }
    // 再统一按 TrackId 从小到大排序
    // allClips.sort((a, b) => a.TrackId - b.TrackId);
    return allClips
  }
  public getImages() {
    // 先合并所有 VideoTrackClips
    let allClips: any[] = [];
    if (this.timeline.timeline.VideoTracks?.length > 0) {
      this.timeline.timeline.VideoTracks.forEach((item) => {
        if (Array.isArray(item.VideoTrackClips) && item.Type === 'Image') {
          allClips = allClips.concat(item.VideoTrackClips);
        }
      });
    }
    // 再统一按 TrackId 从小到大排序
    // allClips.sort((a, b) =>  b.TrackId - a.TrackId);
    return allClips
  }
  public updateClipHiddenByClipId() {
    const curClipId = clipIdStore.getClipId();
    if (!this.timeline?.timeline?.VideoTracks) return;
    this.timeline.timeline.VideoTracks.forEach(track => {
      if (Array.isArray(track.VideoTrackClips)) {
        track.VideoTrackClips.forEach(clip => {
          if (clip.Id > curClipId) {
            clip.hidden = true;
          } else {
            clip.hidden = false;
          }
        });
      }
    });
  }

  /**
   * 将元素数据转换为 timeline 格式
   * @param elements 元素数据数组
   * @returns 转换后的 timeline 数据
   */
  public convertToTimeline(elements: any[]): TimelineData {
    const timelineData: TimelineData = {
      timeline: {
        VideoTracks: []
      }
    };

    // 按 z_index 排序，确保层级正确
    const sortedElements = [...elements].sort((a, b) => (a.z_index || 0) - (b.z_index || 0));

    sortedElements.forEach((element, index) => {
      const trackId = index + 1;
      const clipId = index + 1;

      const baseClip = {
        Id: clipId,
        TrackId: trackId,
        Start: 0,
        End: 10, // 默认10秒
        StartAt: 0,
        hidden: false,
        type: element.type,
        z_index: element.z_index || 0,
        lock: element.lock || false,
        tips: element.tips || ''
      };

      if (element.type === 'video') {
        timelineData.timeline.VideoTracks.push({
          Id: trackId,
          Name: `视频轨道 ${trackId}`,
          VideoTrackClips: [{
            ...baseClip,
            type: 'Video',
            Source: {
              Type: 'video',
              Src: element.url,
              Width: element.width,
              Height: element.height,
              Duration: 10 // 默认10秒
            },
            Transform: {
              Position: {
                X: element.left,
                Y: element.top
              },
              Size: {
                Width: element.width,
                Height: element.height
              },
              Rotation: 0,
              Opacity: 1
            }
          }]
        });
      } else if (element.type === 'text') {
        timelineData.timeline.VideoTracks.push({
          Id: trackId,
          Name: `文字轨道 ${trackId}`,
          VideoTrackClips: [{
            ...baseClip,
            type: 'SubTitle',
            Text: {
              Content: element.content,
              FontSize: element.font_size,
              FontFamily: element.font_family,
              Color: element.color,
              BackgroundColor: element.bg_color || 'transparent',
              StrokeColor: element.stroke_color || 'transparent',
              StrokeWidth: element.stroke || 0,
              TextAlign: element.text_align || 'center',
              LetterSpacing: element.letter_spacing || 0,
              LineHeight: element.line_height || 1,
              Bold: element.weight || false,
              Italic: element.italic || false,
              Underline: element.underline || false
            },
            Transform: {
              Position: {
                X: element.left,
                Y: element.top
              },
              Size: {
                Width: element.width,
                Height: element.height
              },
              Rotation: 0,
              Opacity: 1
            }
          }]
        });
      } else if (element.type === 'stickers') {
        timelineData.timeline.VideoTracks.push({
          Id: trackId,
          Name: `贴纸轨道 ${trackId}`,
          VideoTrackClips: [{
            ...baseClip,
            type: 'Image',
            Source: {
              Type: 'Image',
              Src: element.src || element.id,
              Width: element.width,
              Height: element.height
            },
            Transform: {
              Position: {
                X: element.left,
                Y: element.top
              },
              Size: {
                Width: element.width,
                Height: element.height
              },
              Rotation: 0,
              Opacity: 1
            }
          }]
        });
      }
    });

    return timelineData;
  }
}

const store = new YsVideoStore();
export default store;
